export default "__VITE_ASSET__780b3ed9__"